module.exports = __webpack_public_path__ + "img/show_cn_text_1.9bc38d53.png";